import React from "react";
import { useTranslation } from "react-i18next";
import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterEnumValue from "./IDataFilterEnumValue";
import IDataFilterProps from "../IDataFilterProps";
import FormGroup from "features/shared/forms/components/FormGroup";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

const DataFilterEnumCheckBox = (props: IDataFilterProps) => {
  // translation
  const { t } = useTranslation([
    props.filterDescriptor.valueTranslationPath || "",
  ]);
  const tLables = useTranslation("shared\\dataFilters").t;

  const handleOnChangeCheckBoxForEnum = (
    e: React.ChangeEvent<HTMLInputElement>,
    enumName: string
  ) => {
    const checked: boolean = e.target.checked;
    const name: string = e.target.name;
    let newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === enumName);
    if (!descriptor) return;

    // Získám hodnotu z descriptoru
    const value = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.key === name
    );

    // Nastavím hodnotu
    if (value) {
      value.value = checked;
    } else {
      // Pokud nenajdu, vytvořím novou
      (descriptor.value as IDataFilterEnumValue[]).push({
        key: name,
        value: checked,
      });
    }

    // Update
    props.setDescriptors(newDescriptors);
  };

  const renderCheckBox = (
    filterDescriptor: IDataFilterDescriptor,
    index: number
  ): JSX.Element => {
    const enumValue = filterDescriptor.value as IDataFilterEnumValue;

    return (
      <div
        key={index}
        className="custom-control custom-checkbox"
        hidden={enumValue.hidden}
      >
        <input
          type="checkbox"
          className="custom-control-input"
          id={enumValue.key}
          name={enumValue.key}
          checked={enumValue.value}
          aria-describedby="filterInput"
          onChange={(e) =>
            handleOnChangeCheckBoxForEnum(e, filterDescriptor.name)
          }
        />
        <label className="custom-control-label" htmlFor={enumValue.key}>
          {t(enumValue.key)}
        </label>
      </div>
    );
  };

  const renderEnumCheckBox = (
    filterDescriptor: IDataFilterDescriptor
  ): JSX.Element | null => {
    // Render checkboxů pro jednotlivé klíče enumu
    let enumCheckboxes: JSX.Element[] = [];
    // Values stavy pro jednotlivé enumy
    const enumValues = filterDescriptor.value as IDataFilterEnumValue[];

    enumValues.forEach((value, index) => {
      // Nový descriptor a render
      const newDescriptor: IDataFilterDescriptor = {
        ...filterDescriptor,
        value: value,
      };

      enumCheckboxes.push(renderCheckBox(newDescriptor, index));
    });

    // Vracím blok vyrenderovaných checkboxů pro enum hodnoty
    return (
      <FormGroup key={props.reactKey} labelText={getTranslatedFormText(props.filterDescriptor, "label", tLables)}>
        {enumCheckboxes}
      </FormGroup>
    );
  };

  return <>{renderEnumCheckBox(props.filterDescriptor)}</>;
};

export default DataFilterEnumCheckBox;
